import React from "react";
import { connect } from "react-redux";
import { Field, FieldArray } from "formik";

import Box from "./Box";
import Row from "./Row";

import Select from "../../DataEntry/Select";
import ManageHolidayHour from "../modal/ManageHolidayHour";

class HolidayHour extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
  }

  componentDidUpdate(prevProps: any, _prevState: any) {
    const { holidayHour, holidayHours, formik } = this.props;
    if (holidayHours.length !== prevProps.holidayHours.length) {
      if (
        holidayHours.length &&
        !holidayHours.find((elm: any) => elm.id === holidayHour)
      )
        formik.setFieldValue("holidayHour", holidayHours[0].id);

      const reconciledData = [];
      holidayHours.forEach((elm: any, idx: number) => {
        reconciledData[idx] =
          formik.values.holidayHours.find((c: any) => c.id === elm.id) || elm;
      });
      formik.setFieldValue("holidayHours", reconciledData);
    }
  }

  render() {
    const {
      formik: { isSubmitting, values },
      holidayHours,
      locationId,
      permissions,
      viewOnly,
    } = this.props;

    return (
      <Box title="Holiday Hour(s)">
        <header className="text-center" style={{ paddingTop: "0px"}}>
          <Field
            name="holidayHour"
            className="smart-form-control"
            component={Select}
            style={{ width: "98%" }}
            list={holidayHours.map((c: any) => [c.id, c.title])}
            disabled={isSubmitting}
          />
          <br />
        </header>
        <br />

        <FieldArray
          name="holidayHours"
          render={() =>
            holidayHours.map((holidayHour: any, idx: number) => (
              <div
                key={holidayHour.id}
                style={{
                  display:
                    values.holidayHour == holidayHour.id ? "block" : "none",
                }}
              >
                <Field name={`holidayHours.${idx}.id`} type="hidden" />
                <Row
                  label="Monday"
                  name={`holidayHours.${idx}.monday`}
                  disabled={viewOnly || isSubmitting}
                />
                <Row
                  label="Tuesday"
                  name={`holidayHours.${idx}.tuesday`}
                  disabled={viewOnly || isSubmitting}
                />
                <Row
                  label="Wednesday"
                  name={`holidayHours.${idx}.wednesday`}
                  disabled={viewOnly || isSubmitting}
                />
                <Row
                  label="Thursday"
                  name={`holidayHours.${idx}.thursday`}
                  disabled={viewOnly || isSubmitting}
                />
                <Row
                  label="Friday"
                  name={`holidayHours.${idx}.friday`}
                  disabled={viewOnly || isSubmitting}
                />
                <Row
                  label="Saturday"
                  name={`holidayHours.${idx}.saturday`}
                  disabled={viewOnly || isSubmitting}
                />
                <Row
                  label="Sunday"
                  name={`holidayHours.${idx}.sunday`}
                  disabled={viewOnly || isSubmitting}
                />
                <Row
                  label="Bus. Of. Days"
                  name={`holidayHours.${idx}.bus_of_days`}
                  disabled={viewOnly || isSubmitting}
                />
                <Row
                  label="Off. Hours"
                  name={`holidayHours.${idx}.off_hours`}
                  disabled={viewOnly || isSubmitting}
                />
                <Row
                  label="New Yrs Eve"
                  name={`holidayHours.${idx}.new_year_eve`}
                  disabled={viewOnly || isSubmitting}
                />
                <Row
                  label="New Yrs Day"
                  name={`holidayHours.${idx}.new_year_day`}
                  disabled={viewOnly || isSubmitting}
                />
                <Row
                  label="Good Friday"
                  name={`holidayHours.${idx}.good_friday`}
                  disabled={viewOnly || isSubmitting}
                />
                <Row
                  label="East Sunday"
                  name={`holidayHours.${idx}.east_sunday`}
                  disabled={viewOnly || isSubmitting}
                />
                <Row
                  label="Memorial D."
                  name={`holidayHours.${idx}.memorial_day`}
                  disabled={viewOnly || isSubmitting}
                />
                <Row
                  label="July 4th"
                  name={`holidayHours.${idx}.july_4th`}
                  disabled={viewOnly || isSubmitting}
                />
                <Row
                  label="Labor Day"
                  name={`holidayHours.${idx}.labor_day`}
                  disabled={viewOnly || isSubmitting}
                />
                <Row
                  label="Thanks G."
                  name={`holidayHours.${idx}.thanks_giving`}
                  disabled={viewOnly || isSubmitting}
                />
                <Row
                  label="Chrism. Eve"
                  name={`holidayHours.${idx}.christmas_eve`}
                  disabled={viewOnly || isSubmitting}
                />
                <Row
                  label="Chrism. Day"
                  name={`holidayHours.${idx}.christmas_day`}
                  disabled={viewOnly || isSubmitting}
                />
                <Row
                  label="Alt. H1"
                  name={`holidayHours.${idx}.alt_h1`}
                  disabled={viewOnly || isSubmitting}
                />
                <Row
                  label="Alt. H1 HRS"
                  name={`holidayHours.${idx}.alt_h1_hours`}
                  disabled={viewOnly || isSubmitting}
                />
                <Row
                  label="Alt. H2"
                  name={`holidayHours.${idx}.alt_h2`}
                  disabled={viewOnly || isSubmitting}
                />
                <Row
                  label="Alt. H2 HRS"
                  name={`holidayHours.${idx}.alt_h2_hours`}
                  disabled={viewOnly || isSubmitting}
                />
              </div>
            ))
          }
        />

        <div className="row" style={{ paddingRight: "45px" }}>
          <div
            className="col-md-12 text-right"
            style={{ padding: "10px  20px" }}
          >
            {permissions.location_manage_holiday_hours && !viewOnly ? (
              <ManageHolidayHour locationId={locationId} />
            ) : (
              <a className="cursor-not-allowed">Manange</a>
            )}
          </div>
        </div>
      </Box>
    );
  }
}

const mapStateToProps = (state: any, _props: any) => ({
  holidayHours: state.holidayHours.data,
  locationId: state.location.id,
  permissions: state.permissions.data,
});

const mapDispatchToProps = (_dispatch: Function) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(HolidayHour);
